const scrollHandler = (wrapperRef, reverse = false) => () => {
	const { current } = wrapperRef;
	const scrolledSoFar = current.scrollLeft;
	const TO_SCROLL = reverse
		? -600
		: 600;
	current.scroll({
		left: scrolledSoFar + TO_SCROLL,
		behavior: 'smooth',
	});
};

export default scrollHandler;
